import { Link } from "react-router-dom";
import type { Dashboard } from "../../api/dashboard";
import { Card } from "../../components/ui";
import { SiteMap } from "./SiteMap";

/** Where the located sites are, and how many are not on the map at all. The
 * missing ones are said out loud, with a way to them, because a map cannot
 * show what it does not have and nobody counts the absent dots. */
export function MapCard({ data, colours }: { data: Dashboard; colours: Record<string, string> }) {
  const located = data.map_sites.length;
  const missing = data.unlocated_sites;
  return (
    <Card className="dash-card dash-map" title="Map" sub={`${located} located site${located === 1 ? "" : "s"}, coloured by status`}>
      <SiteMap sites={data.map_sites} colours={colours} />
      {missing > 0 ? (
        <Link className="go-link map-missing" to="/sites?not_located=on">
          {missing} site{missing === 1 ? " has" : "s have"} no position →
        </Link>
      ) : null}
    </Card>
  );
}
